export const WINDOW_ID_NONE = -1;
export const WINDOW_ID_CURRENT = -2;

export const TAB_ID_NONE = -1;

export const PROTOCOL = 'chrome-extension';
export const PROTOCOL_SCHEME = `${PROTOCOL}://`;
